var _rect, _rect2, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSquares2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 48,
    viewBox: "0 0 48 48",
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 16,
    width: 16,
    x: 8,
    y: 24
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#D9D9D9",
    height: 16,
    width: 16,
    x: 24,
    y: 8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#D9D9D9",
    height: 16,
    width: 16,
    x: 8,
    y: 8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    fill: "#2A5BDF",
    height: 16,
    width: 16,
    x: 24,
    y: 24
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquares2);
export default __webpack_public_path__ + "static/media/Squares2.8d99b685b6a5c7d92f3a6f76e00ac299.svg";
export { ForwardRef as ReactComponent };